<script>
import { email, required } from "vuelidate/lib/validators";
import SalesService from "@services/resources/SalesService";
import ActionsModal from "../modals/ActionsModal.vue";

const service = SalesService.build();

export default {
  emits: ["reload"],
  components: {
    ActionsModal,
  },
  props: {
    sale: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  validations: {
    email: { required, email },
  },
  computed: {
    actualEmail() {
      return this.sale.client && this.sale.client.email ? this.sale.client.email : "";
    },
  },
  data() {
    return {
      loading: false,
      email: "",
      submitted: false,
      errorMessage: "",
    };
  },
  methods: {
    async changeEmail() {
      this.submitted = true;
      this.errorMessage = "";
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      this.loading = true;

      try {
        await service.updateClientEmail(this.$route.params.id, this.email.trim());

        this.$bvToast.toast(`E-mail alterado com sucesso!`, {
          title: "Sucesso!",
          variant: "success",
          autoHideDelay: 5000,
          appendToast: true,
        });

        this.$bvModal.hide("email-modal");

        this.$emit("reload");
      } catch (e) {
        this.errorMessage = this.getErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
    getErrorMessage(error) {
      const response = error && error.response;

      if (!response) {
        return "Não foi possível alterar o e-mail do cliente. Verifique sua conexão e tente novamente.";
      }

      if (response.status === 403) {
        return "Você não tem permissão para alterar o e-mail desta venda.";
      }

      const data = response.data || {};

      if (response.status === 422 && data.errors) {
        const messages = Object.values(data.errors).reduce(
          (all, fieldMessages) => all.concat(fieldMessages),
          []
        );

        if (messages.length) {
          return messages[0];
        }
      }

      return data.message || "Não foi possível alterar o e-mail do cliente.";
    },
    async handleAction(step) {
      if (step === 3) {
        await this.changeEmail();
      }
    },
    clearError() {
      this.errorMessage = "";
    },
    resetForm() {
      this.email = "";
      this.submitted = false;
      this.errorMessage = "";
      this.$v.$reset();
    },
  },
};
</script>

<template>
  <ActionsModal
    id="email-modal"
    type="email"
    title="Alterar e-mail"
    description="Esta ação alterará o e-mail do cliente no sistema."
    :alert="{
      description:
        'Certifique-se de ter confirmado o novo e-mail com o cliente antes de prosseguir.',
    }"
    :loading="loading"
    :error-message="errorMessage"
    :sale="sale"
    @submit="handleAction"
    @hidden="resetForm"
  >
    <label for="current-email" class="email-modal__field">
      E-mail atual
      <b-form-input
        id="current-email"
        :value="actualEmail"
        type="email"
        class="form-control"
        disabled
        style="background: #f0f2f5; border: 0"
      />
    </label>
    <label for="new-email" class="email-modal__field">
      Novo e-mail
      <b-form-input
        id="new-email"
        v-model="email"
        type="email"
        placeholder="Digite o novo e-mail."
        class="form-control"
        :state="submitted ? !$v.email.$error : null"
        @input="clearError"
      />
      <b-form-invalid-feedback v-if="submitted && $v.email.$error">
        Preencha o e-mail corretamente.
      </b-form-invalid-feedback>
    </label>
  </ActionsModal>
</template>

<style lang="scss">
.email-modal__field {
  display: block;
  margin-bottom: 18px;
  width: 100%;

  .form-control {
    box-sizing: border-box;
    height: 48px;
    margin-top: 8px;
  }
}
</style>
